import React from 'react';
import './index.css';
import App from './App';
import ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import reportWebVitals from './reportWebVitals';

/*
 * Nested dialogs (New brand / New category inside the product editor, and
 * the like) must open above the dialog that launched them. react-modal
 * appends each portal to <body> on mount, and a child mounts before its
 * parent, so a nested dialog's portal lands EARLIER in the DOM and paints
 * underneath. Every overlay shares one z-index (index.css,
 * `.ReactModal__Overlay`), and on open the portal is moved to the end of
 * <body>, so whichever dialog opened last is on top. Focus is restored
 * because moving a node blurs whatever was focused inside it. No screen
 * passes its own onAfterOpen; one that does opts out of this.
 */
(Modal as any).defaultProps.onAfterOpen = ({overlayEl}: {overlayEl?: HTMLElement}) => {
  const portal = overlayEl?.parentElement;
  const host = portal?.parentElement;
  if (!portal || !host || host.lastElementChild === portal) return;
  const active = document.activeElement as HTMLElement | null;
  host.appendChild(portal);
  if (active && portal.contains(active)) active.focus({preventScroll: true});
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
